import { Injectable } from '@angular/core';
import { AuthService } from '../services.module/auth.service';
import { PartnerApiService } from '../../generated/api/partner/partner.service';
import { ChangeProfilDataRequest, PartnerProfilData } from '../../generated/api/kreditportalBackendAPI.schemas';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PartnerService {

    constructor(
        private readonly authService: AuthService,
        private readonly partnerApiService: PartnerApiService
    ) {
    }

    getPartner(): Observable<PartnerProfilData> {
        if (this.authService.isMaklerOrVermittler() && !this.authService.isActiveKunde4Kunde()) {
            // wenn ich Makler bin und nicht Basis-Daten für einen Klienten will.
            return of(null);
        }

        const ordnungsbegriff = this.authService.determineKundennummer(this.authService.getActiveKunde().vsnr);

        return this.partnerApiService.getProfilData(ordnungsbegriff);
    }

    changeProfilData(changeProfilDataRequest: ChangeProfilDataRequest): Observable<void> {
        return this.partnerApiService.changeProfilData(changeProfilDataRequest)
    }

}
